import { SharedStoreState } from '../types';
import { IdentityProviderState } from '../types/login.types';

export const selectLoginContext = (
	state: SharedStoreState,
): IdentityProviderState => state.loginContext;
